<template>
    <div class="center">
        <div class="top"></div>
        <div class="flex"></div>
        
        <img :src="this.$store.state.logo" alt="" />
        
        <h1>Desculpe-nos!</h1>
        <p>Estamos fechados no momento.</p>
         <div style="background: white;width: 200px;padding:var(--padding-padrao);border-radius: var(--border-radius-padrao);">
            <div v-for="dia in funcionamento.horario" :key="dia.dia">
                <div style="display: flex;align-items: center;justify-content:space-between;font-style: italic;">
                    <h3 style="color: black;">{{ dia.dia }}</h3>
                    <div v-if="dia.periodos.length">
                        <div v-for="(p, i) in dia.periodos" :key="i">
                            <h3 style="color: green;font-weight: bold;">
                                {{ p.inicio }} - {{ p.fim }}
                            </h3>
                        </div>
                    </div>
                    <h3 v-else style="color: green;font-weight: bold;">Fechado</h3>
                </div>
                <hr/>
            </div>
            <!-- <p>*Horário de funcionamento do Delivery Web</p> -->
        </div>
        <br>
        <div v-if="descricaoAberturaCasa != null && descricaoAberturaCasa != ''">
            <p>{{ descricaoAberturaCasa }}</p>
        </div>
        
        <div class="flex"></div>
        <div class="bottom"></div>
    </div>
</template>

<script>
export default {
    name: "CasaFechadaView",
    props: { descricaoAberturaCasa: String},
    data(){
        return {
            funcionamento: this.$store.state.horaDeFuncionamentoDelivery,
        }
    }
}
</script>

<style scoped>

.flex {
    flex: 1; 
}

.top, .bottom {
    height: 15vh;
    width: 80vw;
}

.top {background: linear-gradient(to top, rgba(255, 255, 255, 0.3), transparent 100%)}

.bottom {background: linear-gradient(to bottom, rgba(255, 255, 255, 0.3), transparent 100%)}

.center {
    height: 100vh;
    color: white;
}

p {text-align: center; margin-inline: 15%;}

img {
    padding-block: var(--padding-padrao);
    width: 40%;
}

</style>